import { inject, Injectable, Injector } from '@angular/core';
import { UserPersistentStorageService } from '@app/core/service/user-persistent-storage.service';
import { SentryErrorHandler, setUser } from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class ValchemyErrorHandler extends SentryErrorHandler {
  private _injector = inject(Injector);

  public constructor() {
    super({
      showDialog: false
    });
  }

  public handleError(error: unknown): void {
    const user = this._injector
      .get(UserPersistentStorageService, null)
      ?.getPersistedUser();
    if (user) {
      setUser({
        id: user._id,
        email: user.email,
        name: user.firstName + ' ' + user.lastName
      });
    } else {
      setUser(null);
    }
    super.handleError(error);
  }
}
